module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-SPORT-3.ca3c6306.jpg";